import { Disclosure } from "@headlessui/react";
import {
  ClipboardDocumentListIcon,
  PrinterIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { Tooltip } from "@material-ui/core";
import { ChevronRight, TocSharp } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";
import AddButton from "../../../../components/AddButton";
import {
  leShowState,
  ledAddState,
  ledEditState,
  rowForEditLE,
  leasedEquipmentSaving,
  leFromOffice,
  lEViewData,
  leasedEquipmentOfficeId,
} from "../atom/atom";
import CloseIconButton from "../../../../components/CloseIconButton";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import { mainSelectedTab, urlPath } from "../../atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useGetLeasedEquipmentByRecordNumber } from "../hooks/useGetLeasedEquipmentByRecordNumber";
import { useGetLeasedEquipment } from "../hooks/useGetLeasedEquipment";
import DownloadButton from "../../../../components/DownloadButton";
import useDownloadLEFiles from "../hooks/useDownloadLEFiles";
import { toast } from "../../../../components/toastNotification";
import { downloadSourceFile } from "../../../../actions/CarrierAgreementMgmt/Carrier";
import { file } from "@babel/types";
import { useGetLeasedEquipmentByOfficeId } from "../hooks/useGetLeasedEquipmentByOfficeId";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { VendorTabs } from "../../../VendorTab/VendorTab";
import moment from "moment";
interface LeasedEquipmentProp {
  rowData: any;
  handleEdit: any;
  rowIsExpanded: boolean;
  onClickCancelShow;
  setIsAdd;
  viewFromOffice?: boolean;
}

export const LeasedEquipmentRowDetails: React.FC<LeasedEquipmentProp> = ({
  rowData,
  onClickCancelShow,
  setIsAdd,
  handleEdit,
  rowIsExpanded,
  viewFromOffice,
}) => {
  const [leasedEquipmentDetails, setLeasedEquipmentDetails] = useState<any>();
  const setAddState = useSetRecoilState(ledAddState);
  const setEditState = useSetRecoilState(ledEditState);
  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewPermission = PERMISSIONS.permission_leasedequipment_view;
  const addPermission = PERMISSIONS.permission_leasedequipment_add;
  const editPermission = PERMISSIONS.permission_leasedequipment_edit;

  const [fileNameDL, setFileNameDL] = useState<string>("");
  const [enabledDownload, setEnabledDownload] = useState(false);
  const { data: leFiles } = useDownloadLEFiles({
    fileName: fileNameDL,
    enabledDownloadFile: enabledDownload,
  });
  const [, setleOfficeId] = useRecoilState(leasedEquipmentOfficeId);

  useEffect(() => {
    if (fileNameDL) {
      setEnabledDownload(true);
    }
  }, [fileNameDL]);

  const downloadFile = (fileName) => {
    try {
      downloadSourceFile(fileName).then((content) => {
        if (content.status === 200) {
          var url = window.URL.createObjectURL(content.data);
          let tempLink = document.createElement("a");
          tempLink.href = url;
          tempLink.setAttribute("download", fileName);
          tempLink.click();
          toast.fire("Success", "File Downloaded Successfully", "success");
        }
        if (content.status === 400) {
          toast.fire("Error Downloading File:", "File not found", "error");
        }
      });
    } catch (error) {
      toast.fire(
        "Failed to Download File",
        "Server Error: Cannot download file due to: " + error,
        "error"
      );
    }
  };

  const {
    data: leasedEquipmentData,
    isFetching,
    isSuccess,
  } = useGetLeasedEquipmentByRecordNumber(rowData?.recordNumber);
  useEffect(() => {
    if (isSuccess && leasedEquipmentData) {
      setLeasedEquipmentDetails(leasedEquipmentData);
    }
  }, [isSuccess, leasedEquipmentData]);

  return (
    <>
      {leasedEquipmentDetails && (
        <>
          <div className="flex justify-between pb-1 border-secondary border-b-2">
            <div className="flex gap-2 items-center">
              <div>
                <PrinterIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Leased Equipment
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  {"LE-" +
                    String(leasedEquipmentDetails.recordNumber)?.padStart(
                      4,
                      "0"
                    )}
                </h1>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center gap-2">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="Add"
                    onClick={() => {
                      setIsAdd(true);
                      setAddState(true);
                      setleOfficeId(undefined);
                    }}
                  />
                ) : (
                  ""
                )}
                {userPermissions.includes(editPermission) ? (
                  <EditOutlineButton
                    buttonText="Edit"
                    className={""}
                    disabled={false}
                    onClick={() => {
                      handleEdit(leasedEquipmentDetails);
                    }}
                  />
                ) : (
                  ""
                )}
              </div>

              <CloseIconButton onClick={() => onClickCancelShow()} />
            </div>
          </div>
          <div className="bg-bgDB">
            {rowIsExpanded ? (
              <div className="mt-4 bg-white rounded-lg box-shadow">
                <div className="text-quinary font-bold font-sans py-2 px-8">
                  Main Section
                </div>
                <div className="">
                  <div className="grid grid-cols-1 sm:grid-cols-2">
                    <div className="p-2 divide-y">
                      <div className="grid grid-cols-3 p-2">
                        <label className="col-span-1 mx-4 expandedLabel fontExpand">
                          Record Number:
                        </label>

                        <div className="col-span-2 expandedData fontExpand">
                          <span className="pr-2">
                            {"LE-" +
                              String(
                                leasedEquipmentDetails.recordNumber
                              )?.padStart(4, "0")}
                          </span>
                        </div>
                      </div>
                    </div>
                    {leasedEquipmentDetails?.officeName?.length > 0 && (
                      <div className="p-2 divide-y">
                        <div className="grid grid-cols-3 p-2">
                          <label className="col-span-1 mx-4 expandedLabel fontExpand">
                            Office Name:
                          </label>
                          <div className="col-span-2 expandedData fontExpand">
                            <span className="pr-2">
                              <div
                                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                                onClick={() => {
                                  const url = "/officesettings/officesetting";
                                  history.push({
                                    pathname: url,
                                    state: {
                                      pathname: url,
                                      officeId: leasedEquipmentDetails.officeId,
                                      action: "LeasedEquipment",
                                    },
                                  });
                                  let userTabs = [
                                    {
                                      to: "",
                                    },
                                  ];
                                  [...OfficeTabs].forEach((tabs) => {
                                    let temp = [...userPermissions].filter(
                                      (user) => user === tabs.permission
                                    );
                                    if (temp.length > 0)
                                      userTabs.push({
                                        to: tabs.to,
                                      });
                                  });
                                  userTabs.shift();
                                  const index = userTabs.findIndex(
                                    (c) => c.to === url
                                  );
                                  setSelectedIndex(index);
                                }}
                              >
                                {leasedEquipmentDetails.officeName}
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    {leasedEquipmentDetails?.vendorStorageName?.length > 0 && (
                      <div className="p-2 divide-y">
                        <div className="grid grid-cols-3 p-2">
                          <label className="col-span-1 mx-4 expandedLabel fontExpand">
                            Vendor Name:
                          </label>
                          <div className="col-span-2 expandedData fontExpand">
                            <span className="pr-2">
                              <div
                                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                                onClick={() => {
                                  const url = "/vendortab/vendor";
                                  history.push({
                                    pathname: url,
                                    state: {
                                      vendorId:
                                        leasedEquipmentDetails.vendorStorageId,
                                      leasedEquipmentDetails:
                                        leasedEquipmentDetails,
                                      action: "ToVendor",
                                    },
                                  });
                                  window.location.reload();
                                  let userTabs = [
                                    {
                                      to: "",
                                    },
                                  ];
                                  [...OfficeTabs].forEach((tabs) => {
                                    let temp = [...userPermissions].filter(
                                      (user) => user === tabs.permission
                                    );
                                    if (temp.length > 0)
                                      userTabs.push({
                                        to: tabs.to,
                                      });
                                  });
                                  userTabs.shift();
                                  const index = userTabs.findIndex(
                                    (c) => c.to === url
                                  );
                                  setSelectedIndex(index);
                                }}
                              >
                                {leasedEquipmentDetails.vendorStorageName}
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {rowIsExpanded ? (
              <Disclosure defaultOpen>
                {({ open }) => (
                  <>
                    <div className="mt-2 bg-white rounded-lg box-shadow">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRight
                          className={`${
                            open ? "transform rotate-90" : ""
                          } text-gray-500 w-5 h-5 `}
                        />
                        <span className="disclosureLabel ml-2">
                          Details Section
                        </span>
                      </Disclosure.Button>
                      <Disclosure.Panel className="text-xxs">
                        <div className="">
                          <div className="grid grid-cols-1 sm:grid-cols-2">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Type:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  <span className="pr-2">
                                    {leasedEquipmentDetails.typeName}
                                  </span>
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Make:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  <span className="pr-2">
                                    {leasedEquipmentDetails.makeName}
                                  </span>
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Model/Version:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  <span className="pr-2">
                                    {
                                      leasedEquipmentDetails?.modelDescription
                                        ? leasedEquipmentDetails?.model +
                                          " (" +
                                          leasedEquipmentDetails?.modelDescription +
                                          ")"
                                        : leasedEquipmentDetails?.model
                                      // leasedEquipmentDetails?.make ===
                                      //   "Quadient" ||
                                      // leasedEquipmentDetails?.make ===
                                      //   "Pitney Bows"
                                      //   ? leasedEquipmentDetails?.model +
                                      //     " (" +
                                      //     leasedEquipmentDetails?.modelDescription +
                                      //     ")"
                                      //   : leasedEquipmentDetails?.model
                                    }
                                  </span>
                                </div>
                              </div>
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Equipment ID/Serial Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.serialNumber}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Supply Alert Profile:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {
                                        leasedEquipmentDetails.supplyAlertProfileName
                                      }
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Customer Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.customerNumber}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Vendor Location Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {
                                        leasedEquipmentDetails.vendorLocationNumber
                                      }
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Purchasing Vendor & Phone Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {
                                        leasedEquipmentDetails.purchasingVendorNumber
                                      }
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Lease Amount:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.leaseAmount}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Previous Location:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {
                                        leasedEquipmentDetails.previousOfficeName
                                      }
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Returned Equipment RM#:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {
                                        leasedEquipmentDetails.returnedEquipmentRm
                                      }
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Returned Equipment Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.returnedEquipmentDate &&
                                        new Date(
                                          leasedEquipmentDetails.returnedEquipmentDate
                                        ).toLocaleDateString()}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {!viewFromOffice && (
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Tag Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.tagNumber}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>

                            {!viewFromOffice && (
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    IP Address:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.ipaddress}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Status:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.status}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Equipment Returned:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.equipmentReturned
                                        ? "True"
                                        : "False"}
                                    </span>
                                  </div>
                                </div>
                                {leasedEquipmentDetails.status ===
                                  "Storage" && (
                                  <div className="grid grid-cols-3 p-2">
                                    <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                      Inactive Storage:
                                    </label>
                                    <div className="col-span-2 expandedData fontExpand">
                                      <span className="pr-2">
                                        {leasedEquipmentDetails.isActive ===
                                        false
                                          ? "True"
                                          : "False"}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Lease Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.leaseNumber}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Lease Start Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.leaseStartDate &&
                                        new Date(
                                          leasedEquipmentDetails.leaseStartDate
                                        ).toLocaleDateString()}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Lease End Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.leaseEndDate &&
                                        new Date(
                                          leasedEquipmentDetails.leaseEndDate
                                        ).toLocaleDateString()}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Cancellation Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.cancellationDate &&
                                        new Date(
                                          leasedEquipmentDetails.cancellationDate
                                        ).toLocaleDateString()}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Servicing Dealer:
                                  </label>
                                  <div
                                    className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                                    onClick={() => {
                                      const url =
                                        "/officesettings/leasedequipment";
                                      history.push({
                                        pathname: "/vendortab/vendor",
                                        state: {
                                          vendorId:
                                            leasedEquipmentDetails.vendorId,
                                          leasedEquipmentDetails:
                                            leasedEquipmentDetails,
                                          action: "ToVendor",
                                        },
                                      });
                                      window.location.reload();
                                      let userTabs = [
                                        {
                                          to: "",
                                        },
                                      ];
                                      [...OfficeTabs].forEach((tabs) => {
                                        let temp = [...userPermissions].filter(
                                          (user) => user === tabs.permission
                                        );
                                        if (temp.length > 0)
                                          userTabs.push({
                                            to: tabs.to,
                                          });
                                      });
                                      userTabs.shift();
                                      const index = userTabs.findIndex(
                                        (c) => c.to === url
                                      );
                                      setSelectedIndex(index);
                                    }}
                                  >
                                    {leasedEquipmentDetails.name}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Servicing Dealer Phone Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.phone}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Service Dealer Email:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.email}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Toner Request Email:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.tonerRequestEmail}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Toner Request Phone:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.tonerRequestPhone}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
            ) : (
              ""
            )}
            <div className="">
              {rowIsExpanded ? (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <>
                      <div className="mt-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : ""
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Notes Section
                          </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className="text-xxs">
                          <div className="grid grid-cols-1 sm:grid-cols-2">
                            <div className="p-2 divide-y">
                              <div className="grid grid-cols-3 p-2">
                                <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                  Attachments:
                                </label>
                                <div className="col-span-2 expandedData fontExpand divide-y space-y-2 ">
                                  {leasedEquipmentDetails.fileNames.map(
                                    (file) => {
                                      return (
                                        <div className="grid space-x-2 items-center grid-cols-3">
                                          <div className="col-span-2">
                                            {" "}
                                            {file.leasedEquipmentFileName}{" "}
                                          </div>
                                          <div>
                                            <DownloadButton
                                              buttonValue="Download"
                                              onClick={() => {
                                                downloadFile(
                                                  file.leasedEquipmentFileName
                                                );
                                              }}
                                              className={undefined}
                                              disabled={false}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    </>
                  )}
                </Disclosure>
              ) : (
                ""
              )}
            </div>
            <div className="">
              {rowIsExpanded ? (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <>
                      <div className="mt-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : ""
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            System Information
                          </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className="text-xxs">
                          <div className="grid grid-cols-1 md:grid-cols-1">
                            <div className="grid grid-cols-1 sm:grid-cols-2">
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Created By:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.createdBy}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Created Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.createdDate &&
                                        moment(
                                          leasedEquipmentDetails.createdDate
                                        ).format("M/D/YYYY hh:mm A")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2">
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Last Modified By:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.lastModifiedBy}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                                    Last Modified Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <span className="pr-2">
                                      {leasedEquipmentDetails.modifiedDate &&
                                        moment(
                                          leasedEquipmentDetails.modifiedDate
                                        ).format("M/D/YYYY hh:mm A")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </div>
                    </>
                  )}
                </Disclosure>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};
